import type { DatePickerNativeProps } from '@boltenergy-be/design-system'
import { DatePickerNative } from '@boltenergy-be/design-system'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { DATE_FORMAT } from 'constants/constants.ts'

const DateField = ({ hookFormKey = 'date', required = true, ...props }: DatePickerNativeProps & { hookFormKey?: string }) => {
  // i18n
  const { t } = useTranslation('validation')

  // React Hook Form
  const { register, formState } = useFormContext<{ [hookFormKey]: string }>()

  return (
    <DatePickerNative
      {...register(hookFormKey, {
        required: required ? t(($) => $.required) : undefined,
        validate: {
          minDate: (value) =>
            props.min && dayjs(value).isBefore(props.min)
              ? props.min && props.max
                ? t(($) => $.invalid.date.between, {
                    max: dayjs(props.max).format(DATE_FORMAT),
                    min: dayjs(props.min).format(DATE_FORMAT),
                    interpolation: { escapeValue: false }
                  })
                : t(($) => $.invalid.date.min, {
                    minMinusOne: dayjs(props.min).subtract(1, 'days').format(DATE_FORMAT),
                    interpolation: { escapeValue: false }
                  })
              : true,
          maxDate: (value) =>
            props.max && dayjs(value).isAfter(props.max)
              ? props.min && props.max
                ? t(($) => $.invalid.date.between, {
                    max: dayjs(props.max).format(DATE_FORMAT),
                    min: dayjs(props.min).format(DATE_FORMAT),
                    interpolation: { escapeValue: false }
                  })
                : t(($) => $.invalid.date.max, {
                    maxPlusOne: dayjs(props.max).add(1, 'days').format(DATE_FORMAT),
                    interpolation: { escapeValue: false }
                  })
              : true
        }
      })}
      {...props}
      error={formState?.errors?.[hookFormKey]?.message}
    />
  )
}

export default DateField
